import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';
import { useTranslation } from '@common/hooks/translation';

const Checkbox = ({
  disabled, onClick, onChange, checked, id, className = 'checkbox-checkmark', label
}) => (
  <div className="checkbox-wrapper">
    <label className="input-checkbox">
      <input
        id={id}
        type="checkbox"
        disabled={disabled}
        checked={checked}
        className="checkbox"
        onChange={onChange}
        onClick={onClick}
      />
      <span className={className} />
    </label>
    {
        label
      }
  </div>
);

export default Checkbox;

Checkbox.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  className: PropTypes.string,
};
